export default __webpack_public_path__ + "static/media/logo.c807e0b3.svg";